import { createOperationClient } from "@/services/react-query.service/graphql-client";
import { queryKeys } from "@/services/react-query.service/query-keys";
import { useQuery } from "@tanstack/react-query";

import { getIndicatorListQueryDocument } from "./indicator.gql";

export interface UseGetIndicatorListProps {
  workspaceId?: string;
  enabled?: boolean;
}

export const useGetIndicatorListQuery = ({ workspaceId, enabled = true }: UseGetIndicatorListProps) => {
  const queryResult = useQuery({
    queryKey: queryKeys.indicators.list(workspaceId ?? ""),
    queryFn: async () => {
      if (!workspaceId) {
        throw new Error("Workspace ID is required");
      }
      const client = createOperationClient("GetIndicatorList");
      const data = await client.request(getIndicatorListQueryDocument, { input: { workspaceId } });
      return data.indicatorList;
    },
    enabled: enabled && !!workspaceId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });

  return {
    queryResult,
    loading: queryResult.isLoading,
    error: queryResult.error,
    indicatorList: queryResult.data ?? [],
  };
};
